/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from 'react';
import { getResponsiveImage } from '@/componentWebs/NbmImageNew';
import { connect } from 'react-redux';
import { Slider, Tag, Pagination } from 'antd';
import { getLinkProduct, formatNumber, getProfileAfterPrd } from '@/utils/utils';
import CountriesSelect from '@/componentWebs/Common/CountriesSelect';
import VisaComponent from '@/componentWebs/vietnamTickets/VisaComponent';
import BoxSearchFlignhts from '@/componentWebs/vietnamTickets/BoxSearchFlignhts';
import SliderQuangCao from '@/componentWebs/vietnamTickets/SliderQuangCao';
import CountriesCarosel from '@/componentWebs/Common/CountriesCarosel';
import ModalQuestion from '@/componentWebs/vietnamTickets/ModalQuestion';

// import 'moment/locale/vi_VN';
// import locale from 'antd/';

import moment from 'moment';

moment.locale('vi');

const pageSize = 20;

@connect(({ webs: { dataAd } }) => ({
  dataAd,
}))
class Index extends Component {
  state = {
    visibleQuestion: false,
  };

  componentDidMount() {
    const { dispatch } = this.props;
    // dispatch({
    //   type: 'webs/visaCalls',
    //   payload: {
    //     isTrue: true,
    //   }
    // });
  }

  render() {
    const { data, dataSite } = this.props;
    const {
      fromValue,
      toValue,
      dataTabsVisa,
      currentInd,
      dataIntroduse,
      currentIndDetail,
      currentIndVisaList,
      currentIndXemThem,
      activeTabs,
      pagi,
      visibleQuestion,
    } = this.state;

    const mobile =
      (dataSite.siteProfiles && dataSite.siteProfiles.hotline) ||
      (dataSite.places && dataSite.places.mobile);
    const template =
      data.templateLayouts && data.templateLayouts.templates && data.templateLayouts.templates[0];
    const imageResize =
      template && template.templateLayoutTemplates && template.templateLayoutTemplates.imagesResize;
    // console.log(data);
    // const template =
    //   data.templateLayouts && data.templateLayouts.templates && data.templateLayouts.templates[0];
    // const imageResize =
    //   template && template.templateLayoutTemplates && template.templateLayoutTemplates.imagesResize;

    return (
      // Tin tức trang chủ
      <React.Fragment>
        <SliderQuangCao {...this.props} type="visa" />

        <div className="container-normal bannerMobile banner-visa-question flex-b-c">
          <BoxSearchFlignhts typeTab="visa" />
          <div className="visa_question__box hidden-m-t">
            <div className="text">Bạn cần tư vấn về dịch vụ visa ?</div>
            <div className="phone">Gọi Ngay <span style={{ cursor: 'pointer' }} onClick={() => (window.location.href = `tel:${mobile}`)}>{mobile}</span></div>
            <div
              className="btn-kiemtra flex-center"
              onClick={() =>
                this.setState({
                  visibleQuestion: !visibleQuestion,
                })
              }
            >
              Kiểm tra tỷ lệ đậu
            </div>
          </div>
        </div>

        <ModalQuestion visible={visibleQuestion} />

        <section className="khachSan tour">
          <div className="container-normal">
            {/* dia diem (dang de tam an)  */}
            {/* <CountriesCarosel type="visa" /> */}

            {/* Product khach san  */}
            <VisaComponent mobile={mobile} isQuestion visibleQuestionL={() => this.setState({
              visibleQuestion: !visibleQuestion,
            })}
              imageResize={imageResize}
            />
          </div>
          <div className="box-search-mobile box-visa-question-mobile hidden-pc  flex-center">
            <div
              className="btn-kiemtra flex-center"
              onClick={() =>
                this.setState({
                  visibleQuestion: !visibleQuestion,
                })
              }
            >
              Kiểm tra tỷ lệ đậu
            </div>
          </div>
        </section>
        <div className="pagiTuyenBay-top pagi-visa-mobile hidden-pc" />
      </React.Fragment>
    );
  }
}

export default Index;
